import { nanoid } from "@reduxjs/toolkit";
import apiCall from "services/apiCall";
import { saveFile, uploadFile } from "services/file-service";
import showToast from "./showToast";
import { slugify } from "./stringHelpers";

const FILE_SIZE = 5.0;

const isSha1 = (sha1) => {
  let sha1Pattern = new RegExp(/\b([a-fA-F0-9]{40})\b/g);
  return sha1Pattern.test(sha1);
};

async function reduce_image_file_size(base64Str, MAX_WIDTH = 1280, MAX_HEIGHT = 720) {
  let resized_base64 = await new Promise((resolve) => {
    let img = new Image();
    img.src = base64Str;
    img.onload = () => {
      let canvas = document.createElement("canvas");
      let width = img.width;
      let height = img.height;

      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL("image/jpeg", 0.3)); // this will return base64 image results after resize
    };
  });
  return resized_base64;
}

async function image_to_base64(file) {
  let result_base64 = await new Promise((resolve) => {
    let fileReader = new FileReader();
    fileReader.onload = (e) => resolve(fileReader.result);
    fileReader.onerror = (error) => {
      alert("An Error occurred please try again, File might be corrupt");
    };
    fileReader.readAsDataURL(file);
  });
  return result_base64;
}

function calc_image_size(image) {
  let y = 1;
  if (image.endsWith("==")) {
    y = 2;
  }
  const x_size = image.length * (3 / 4) - y;
  return Math.round(x_size / 1024);
}

async function process_image(file, min_image_size = 300) {
  const res = await image_to_base64(file);
  if (res) {
    const old_size = calc_image_size(res);
    if (old_size > min_image_size) {
      const resized = await reduce_image_file_size(res);
      return resized;
    } else {
      return res;
    }
  } else {
    return null;
  }
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr?.[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

const saveAsFile = async (blobName) => {
  const blob = new Blob([blobName]);
  const formData = new FormData();
  formData.append("dosya", blob, nanoid() + ".html");
  formData.append("aciklama", "");
  formData.append("baslik", "");
  return saveFile(formData).then((response) => {
    return response.data.dosyaSHA1;
  });
};

const fileUpload = async (file) => {
  const docFile = file;
  if (typeof docFile !== "undefined" && typeof docFile === "object") {
    const text = docFile.name.split(".").map((_text) => slugify(_text));
    const tempName = text.join(".");
    const temp = new File([docFile], tempName, {
      type: docFile.type
    });
    let uploadDetails = {
      baslik: temp.name,
      dosya: temp
    };
    let result;
    await apiCall({
      service: uploadFile,
      serviceParams: uploadDetails,
      onSuccess: (response) => {
        result = { sha: response.data.dosyaSHA1, uploadDetails };
      },
      onError: (res) => {
        showToast("Dosya yükleme işlemi sırasında hata oluştu", { type: "error" });
        result = { sha: "", uploadDetails: null };
      }
    });
    return result;
  }
};

const checkFileSize = (file) => {
  const size = (file.size / (1024 * 1024)).toFixed(2);
  if (size > FILE_SIZE) {
    showToast(`${file.name} isimli dosya boyutu ${FILE_SIZE}mb'den büyük olduğu için yüklenemez`, {
      type: "warning"
    });
    return false;
  }
  return true;
};

const createImageWithSrc = (src) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
};

export {
  isSha1,
  process_image,
  dataURLtoFile,
  saveAsFile,
  fileUpload,
  checkFileSize,
  createImageWithSrc
};
